import { Reducer } from 'redux';
import {
  GET_RESERVATION, GET_RESERVATION_LIST, PATCH_RESERVATION, ReservationActionTypes, ReservationState, UPDATE_RESRVATION_FILTERS
} from '../types/reservation.types';

const initialState: ReservationState = {
  reservations: [],
  selectedReservation: null,
  postSuccess: null,
  lastFetch: null,
  totalElements: 0,
  totalPages: 1,
  filters: null
};

export const reservationReducer: Reducer<ReservationState> = (
  state: ReservationState = initialState, action
) => {
  const timeOfAction = new Date().getTime();

  switch ((action as ReservationActionTypes).type) {
    case GET_RESERVATION_LIST:
      return {
        ...state,
        reservations: action.payload.page.content,
        selectedReservation: null,
        postSuccess: null,
        lastFetch: timeOfAction,
        totalElements: action.payload.page.totalElements,
        totalPages: action.payload.page.totalPages
      };
    case GET_RESERVATION:
      return {
        ...state,
        postSuccess: null,
        selectedReservation: action.payload.selectedReservation,
        lastFetch: timeOfAction
      };
    case UPDATE_RESRVATION_FILTERS:
      return {
        ...state,
        filters: action.payload.filters,
      };
    case PATCH_RESERVATION:
      return {
        ...state,
        selectedReservation: action.payload.selectedReservation,
        lastFetch: timeOfAction
      };
    default:

      return state;
  }
};
